import { render } from "./imageAndText.vue?vue&type=template&id=4bcb0f79&scoped=true"
import script from "./imageAndText.vue?vue&type=script&lang=js"
export * from "./imageAndText.vue?vue&type=script&lang=js"

import "./imageAndText.vue?vue&type=style&index=0&id=4bcb0f79&lang=scss&scoped=true"

import exportComponent from "E:\\06film\\web\\film-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcb0f79"]])

export default __exports__